/* eslint-disable no-case-declarations */
import actionTypes from 'redux/actions/actionTypes';
import { actionTypes as customTypes } from 'modules/_shared/redux/resetActions';

import initialState from 'redux/initialState';

export default function reducer(plans = initialState.plans, action) {
  switch (action.type) {
    case customTypes.RESET_STATE_SOCIETY:
      return initialState.plans;

    case actionTypes.CREATE_STOCK_PLAN:
      return [...plans, action.plan];

    case actionTypes.GET_STOCK_PLAN:
      return [action.plan];

    case actionTypes.GET_STOCK_PLANS:
      return action.data;

    case actionTypes.UPDATE_STOCK_PLAN:
      return [
        ...plans.filter((plan) => plan['_id'] !== action.plan['_id']),
        action.plan,
      ];

    case actionTypes.DELETE_STOCK_PLAN:
      return [
        ...plans.filter(
          (currentPlan) => currentPlan['_id'] !== action.plan['_id']
        ),
      ];

    default:
      return plans;
  }
}
